import { PerspectiveCamera } from 'three';
import { appMixin } from '../utils/appMixin';

/** @extends PerspectiveCamera */

const INITIAL_FOV = 40;
export class Camera extends appMixin(PerspectiveCamera) {
  constructor(app) {
    super(app, INITIAL_FOV, app.tools.viewport.ratio, 1, 200);
    this.position.set(0, 0.5, 4.5);
    this.lookAt(0, 1, 0);

    this.onResize({ ratio: app.tools.viewport.ratio });
  }

  onResize({ ratio }) {
    this.aspect = ratio;
    // this.fov = INITIAL_FOV / (Math.min(1, ratio) + Math.max(0, ratio - 2) * 0.5);
    this.updateProjectionMatrix();
  }
}
